(function () {
    const setRem = () => document.documentElement.style.fontSize = (document.documentElement.clientWidth) / 1366
    window.addEventListener('DOMContentLoaded', setRem, false)
    window.addEventListener('orientationchange', setRem, false)
  } ())